module.exports = __webpack_public_path__ + "static/who_we_are.7655f714.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/who_we_are.png
// module id = 661
// module chunks = 169858455373905